export enum ScheduledChannelSnapshotListingsSelectionMode {
    INCLUDE = 1,
    EXCLUDE = 2,
    INCLUDE_ALL = 3,
    EXCLUDE_ALL = 4,
}
